import { ChevronLeftIcon } from "@chakra-ui/icons";
import { Box, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { motion, useAnimation } from "framer-motion"

const CardHeader = ({ children, setIsCtaTriggered, id, title, containerControls }) => {
  const contentControls = useAnimation()

  useEffect(() => {
    (async () => {
      await containerControls.start({ height: 'auto' })
      await contentControls.start({ opacity: 1 })
    })();
  }, [])

  const handleBackButtonClick = async () => {
    await containerControls.start({ height: '5rem' });
    setIsCtaTriggered(false);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={contentControls}
      transition={{ duration: 0.3 }}
    >
      <Box marginInline="1rem">
        <Box onClick={handleBackButtonClick} marginBlock={".5rem"} mb="1rem">
          <ChevronLeftIcon ml="-0.6rem" boxSize={10} color="#4848AA" />
        </Box>

        <Box>
          <Text fontSize="14px" fontWeight="700">
            {title}
          </Text>
          <Text fontSize="14px" fontWeight="400" color="gray">
            TC Number: {id}
          </Text>
        </Box>

        <Box>{children}</Box>
      </Box>
    </motion.div>
  );
};

export default CardHeader;
